import Scrolling from '../../utils/class/scrolling';
import NotificationManager from '../../utils/class/notifications';

export default class UserNotifications {
    constructor () {
        this.scrolling = new Scrolling();
        this.NotificationManager = new NotificationManager();

        this.trigger = document.querySelector('#notifications-trigger');
        this.triggerMobile = document.querySelector('#notifications-trigger-mobile');
        this.window = document.querySelector('#notifications-window');
        this.list = document.querySelector('#notifications-list');
        this.loader = document.querySelector('#notifications-loader');

        if ([this.trigger, this.triggerMobile, this.window, this.list, this.loader].some((el) => !el)) return;

        this.notifications = [];

        this.init();
        this.actions();
        this.autoFetch();
    }

    init () {
        this.window.addEventListener('click', (event) => {
            event.stopPropagation();

            this.trigger.classList.remove('active');
            this.triggerMobile.classList.remove('active');
            this.window.classList.remove('active');

            this.scrolling.enable();
        });

        [this.trigger, this.triggerMobile].forEach((el) => {
            el.addEventListener('click', (event) => {
                event.stopPropagation();
    
                this.trigger.classList.toggle('active');
                this.triggerMobile.classList.toggle('active');
                this.window.classList.toggle('active');
    
                if (this.window.classList.contains('active')) {
                    this.scrolling.disable();
    
                    this.update();
                } else {
                    this.scrolling.enable();
                }
            });
        });

        this.window.querySelector('.site-header--notifications-window__inner').addEventListener('click', (event) => event.stopPropagation());
    }

    actions () {
        const trigger = this.window.querySelector('#notifications-menu-trigger');
        const menu = this.window.querySelector('#notifications-menu-window');
        const close = this.window.querySelector('#notifications-close');

        if ([trigger, menu, close].some((el) => !el)) return;

        this.window.addEventListener('click', (event) => {
            event.stopPropagation();

            trigger.classList.remove('active');
            menu.classList.remove('active');
        });

        this.window.querySelector('.site-header--notifications-window__inner').addEventListener('click', (event) => {
            event.stopPropagation();

            trigger.classList.remove('active');
            menu.classList.remove('active');
        });

        trigger.addEventListener('click', (event) => {
            event.stopPropagation();

            trigger.classList.toggle('active');
            menu.classList.toggle('active');
        });

        close.addEventListener('click', (event) => {
            event.stopPropagation();

            this.trigger.classList.remove('active');
            this.triggerMobile.classList.remove('active');
            this.window.classList.remove('active');

            trigger.classList.remove('active');
            menu.classList.remove('active');

            this.scrolling.enable();
        });

        const readAll = this.window.querySelector('#notifications-read');
        const deleteAll = this.window.querySelector('#notifications-delete');

        readAll.addEventListener('click', (event) => {
            event.stopPropagation();

            trigger.classList.remove('active');
            menu.classList.remove('active');

            this.readAllNotifications();
        });

        deleteAll.addEventListener('click', (event) => {
            event.stopPropagation();

            trigger.classList.remove('active');
            menu.classList.remove('active');

            this.deleteAllNotifications();
        });
    }

    transformDate (inputDate) {
        const now = new Date();
        const [datePart, timePart] = inputDate.split(' ');
        const [day, month, year] = datePart.split('.').map(Number);
        const [hour, minute] = timePart.split(':').map(Number);
    
        const inputDateTime = new Date(Date.UTC(year, month - 1, day, hour, minute));
        const diffInSeconds = Math.floor((now - inputDateTime) / 1000);
    
        if (diffInSeconds < 60) return '< 1 min ago';
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours} h ago`;
        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays <= 7) return `${diffInDays} d ago`;
    
        return inputDate;
    }

    async update () {
        this.notifications = [];
        this.list.innerHTML = '';
        this.loader.classList.remove('hidden');

        const generate = (data) => {
            const el = document.createElement('div');

            el.classList.add('site-header--notifications-item');

            let content = ``;

            if (data.url) {
                content += `
                    <a title="User Profile" href="${data.url}" class="site-header--notifications-item-image">
                        <img src="${data.image}" alt="${data.name}">
                    </a>
                `;
            } else {
                content += `
                    <div class="site-header--notifications-item-image">
                        <img src="${data.image}" alt="${data.name}">
                    </div>
                `;
            }

            content += `
                <div class="site-header--notifications-item-content">
                    <p class="site-text site-header--notifications-item-text">
                        ${data.data}
                    </p>
                    <div class="site-text site-header--notifications-item-time">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7.00045" cy="7.00033" r="5.83333" stroke="#333333" stroke-width="0.875"/>
                            <path d="M7.00006 4.66699V6.84423C7.00006 6.94175 7.0488 7.03282 7.12994 7.08691L8.75006 8.16699" stroke="#333333" stroke-width="0.875" stroke-linecap="round"/>
                        </svg>
                        <time>${data.time}</time>
                    </div>
                </div>
            `;

            el.innerHTML = content;

            el.setAttribute('data-id', data.id);

            if (!data.read) {
                el.classList.add('new');
                el.setAttribute('tabindex', 0);
                el.setAttribute('title', 'Mark as read');
            }

            return el;
        }

        const fullfill = () => {
            const sorted = this.notifications.reverse();

            sorted.forEach((item) => item.querySelector('time').textContent = this.transformDate(item.querySelector('time').textContent));

            this.list.append(...sorted);

            setTimeout(() => this.setReadHandlers());
        }

        try {
            await fetch('/wp-json/notifications/v1/notifications')
                .then((response) => response.json())
                .then((data) => {
                    if (data && !data.error) {
                        if (data.data.length) {
                            data.data.forEach((item) => this.notifications.push(generate(item)));

                            fullfill();
                        } else {
                            this.list.innerHTML = `
                                <div class="site-listing--empty">
                                    <div class="site-listing--empty__inner">
                                        <div class="site-listing--empty-image">
                                            <img src="${window.location.origin}/wp-content/themes/pledge-panda/dist/images/panda/success.svg" alt="Nothing here" width="110" height="150">
                                        </div>

                                        <h2 class="h3 site-title">
                                            You don't have any notifications!
                                        </h2>

                                        <p class="site-text">
                                            Here's where you'll get notified in real-time about any updates, changes, or new opportunities related to your projects and jobs.
                                        </p>
                                    </div>
                                </div>
                            `;
                        }

                        setTimeout(() => this.loader.classList.add('hidden'), 1000);
                    } else {
                        this.NotificationManager.sendNotification('error', 'An error occurred...', 'Something went wrong while updating notifications. Please try again');
                    }
                })
                .catch(() => {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', 'Something went wrong while updating notifications. Please try again');
                });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Something went wrong while updating notifications. Please try again');
        }
    }

    setReadHandlers () {
        const items = this.list.querySelectorAll('.site-header--notifications-item.new');
        if (!items || !items.length) return;

        [...items].forEach((item) => {
            item.addEventListener('click', (event) => {
                event.stopPropagation();

                fetch('/wp-json/notifications/v1/mark-read', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ id: item.getAttribute('data-id') })
                })
                .then((response) => response.json())
                .then((data) => {
                    if (data && !data.error) {
                        item.classList.remove('new');

                        const rest = this.list.querySelectorAll('.site-header--notifications-item.new');

                        if (!rest && !rest.length) {
                            this.trigger.classList.remove('has-unread');
                            this.triggerMobile.classList.remove('has-unread');
                        }
                    } else {
                        this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);
                    }
                })
                .catch(() => {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', 'Something went wrong while updating notifications. Please try again');
                });
            });
        });
    }

    async checkNotifications () {
        try {
            const response = await fetch('/wp-json/notifications/v1/notifications');
            const data = await response.json();

            if (data && !data.error) {
                const unread = data.data.some((item) => !item.read);

                this.trigger.classList.toggle('has-unread', unread);
                this.triggerMobile.classList.toggle('has-unread', unread);
            }
        } catch (error) {
            console.error('Failed to fetch notifications:', error);
        }
    }

    autoFetch () {
        this.checkNotifications();

        const interval = setInterval(() => this.checkNotifications(), 10000);

        setTimeout(() => clearInterval(interval), 60000 * 5);
    }

    async readAllNotifications () {
        const rest = this.list.querySelectorAll('.site-header--notifications-item.new');

        if (!rest || !rest.length) {
            this.NotificationManager.sendNotification('success', 'Notifications marked as read!', 'Notifications updated');

            return;
        }

        try {
            await fetch('/wp-json/notifications/v1/read-all', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.NotificationManager.sendNotification('success', 'Notifications marked as read!', 'Notifications updated');

                    this.trigger.classList.remove('has-unread');
                    this.triggerMobile.classList.remove('has-unread');

                    [...rest].forEach((item) => item.classList.remove('new'));
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', 'Something went wrong while updating notifications. Please try again');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Something went wrong while updating notifications. Please try again');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Something went wrong while updating notifications. Please try again');
        }
    }

    async deleteAllNotifications () {
        try {
            await fetch('/wp-json/notifications/v1/delete-all', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.NotificationManager.sendNotification('success', 'Notifications deleted!', 'Notifications updated');

                    this.trigger.classList.remove('has-unread');
                    this.triggerMobile.classList.remove('has-unread');

                    this.update();
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', 'Something went wrong while updating notifications. Please try again');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Something went wrong while updating notifications. Please try again');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Something went wrong while updating notifications. Please try again');
        }
    }
}